import { ContractIAImportState, ContractIAImportUnloadState } from '../../states/Contract.IAImport.States';
import * as actions from '../../actions/Contract.IAImport.Actions';

type KnownAction =
  | actions.ContractIAImportGetHistoryRequestAction
  | actions.ContractIAImportGetHistorySuccessAction
  | actions.ContractIAImportGetHistoryFailureAction;

export default function ContractIAImportGetHistoryReducer(
  state: ContractIAImportState | undefined,
  action: any
): ContractIAImportState {
  const currentState = state ?? ContractIAImportUnloadState;

  switch (action.type) {
    case actions.CONTRACT_IAIMPORT_GETHISTORY_REQUEST:
      // Cleared up front: a history list is meaningless for another contract.
      return {
        ...currentState,
        isGettingHistory: true,
        successGettingHistory: undefined,
        failOnGettingHistory: false,
        history: [],
      };
    case actions.CONTRACT_IAIMPORT_GETHISTORY_SUCCESS:
      return {
        ...currentState,
        isGettingHistory: false,
        successGettingHistory: true,
        failOnGettingHistory: false,
        history: action.processes || [],
      };
    case actions.CONTRACT_IAIMPORT_GETHISTORY_FAILURE:
      return {
        ...currentState,
        isGettingHistory: false,
        successGettingHistory: false,
        failOnGettingHistory: true,
        error: action.error,
      };
    default:
      return currentState;
  }
}
